/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsDtoAdminPingPaymentSettlementDto } from './WebApiIntegrationsDtoAdminPingPaymentSettlementDto';
import {
    WebApiIntegrationsDtoAdminPingPaymentSettlementDtoFromJSON,
    WebApiIntegrationsDtoAdminPingPaymentSettlementDtoFromJSONTyped,
    WebApiIntegrationsDtoAdminPingPaymentSettlementDtoToJSON,
} from './WebApiIntegrationsDtoAdminPingPaymentSettlementDto';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoAdminPingPaymentDisbursementDto
 */
export interface WebApiIntegrationsDtoAdminPingPaymentDisbursementDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentDisbursementDto
     */
    disbursementId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentDisbursementDto
     */
    disbursedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentDisbursementDto
     */
    currency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentDisbursementDto
     */
    amount?: number;
    /**
     * 
     * @type {Array<WebApiIntegrationsDtoAdminPingPaymentSettlementDto>}
     * @memberof WebApiIntegrationsDtoAdminPingPaymentDisbursementDto
     */
    rows?: Array<WebApiIntegrationsDtoAdminPingPaymentSettlementDto> | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoAdminPingPaymentDisbursementDto interface.
 */
export function instanceOfWebApiIntegrationsDtoAdminPingPaymentDisbursementDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoFromJSON(json: any): WebApiIntegrationsDtoAdminPingPaymentDisbursementDto {
    return WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoAdminPingPaymentDisbursementDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disbursementId': !exists(json, 'disbursementId') ? undefined : json['disbursementId'],
        'disbursedAt': !exists(json, 'disbursedAt') ? undefined : (new Date(json['disbursedAt'])),
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'rows': !exists(json, 'rows') ? undefined : (json['rows'] === null ? null : (json['rows'] as Array<any>).map(WebApiIntegrationsDtoAdminPingPaymentSettlementDtoFromJSON)),
    };
}

export function WebApiIntegrationsDtoAdminPingPaymentDisbursementDtoToJSON(value?: WebApiIntegrationsDtoAdminPingPaymentDisbursementDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disbursementId': value.disbursementId,
        'disbursedAt': value.disbursedAt === undefined ? undefined : (value.disbursedAt.toISOString()),
        'currency': value.currency,
        'amount': value.amount,
        'rows': value.rows === undefined ? undefined : (value.rows === null ? null : (value.rows as Array<any>).map(WebApiIntegrationsDtoAdminPingPaymentSettlementDtoToJSON)),
    };
}

